// extracted by mini-css-extract-plugin
module.exports = {"checkItem":"_3Eb5l","select":"_2ZGiy","footer":"l6atO"};